import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui'
import { useToast } from '@/hooks'
import { type Invitation, useMembersMutations } from '@/modules/account'
import { useDialogActions, useDialogData, useDialogIsOpen } from '@/stores'

const dialogId = 'revoke-invitation'

export const RevokeInvitationDialog = () => {
  const { successToast, errorToast } = useToast()
  const open = useDialogIsOpen(dialogId)
  const invitation = useDialogData() as Invitation
  const { closeDialog } = useDialogActions()

  const { revokeInvitation } = useMembersMutations()

  const handleSubmit = () => {
    revokeInvitation(invitation)
      .then(() => successToast('Invitation revoked'))
      .catch((error) => errorToast(`Failed to revoke invitation`, error))
    closeDialog(true)
  }

  return (
    <Dialog open={open} onOpenChange={(open) => !open && closeDialog()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Revoke invitation</DialogTitle>
          <DialogDescription>
            Are you sure you want to revoke the invitation for{' '}
            <strong>{invitation?.email}</strong>? The link will no longer work.
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-end gap-2 pt-4">
          <Button theme="outline" onClick={() => closeDialog()}>
            Cancel
          </Button>
          <Button onClick={handleSubmit} theme="danger">
            Revoke
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}

RevokeInvitationDialog.id = dialogId
